import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { FileUpload } from "../products/fileUpload";

export function useFileUpload(): UseMutationResult<
  any,
  unknown,
  FormData,
  unknown
> {
  return useMutation({
    mutationFn: (body: FormData) => FileUpload.upload(body),
  });
}
export function useFileUploads(): UseMutationResult<
  any,
  unknown,
  FormData[],
  unknown
> {
  return useMutation({
    mutationFn: (body: FormData[]) => FileUpload.multipleUpload(body),
  });
}
